export const removeEmailPrefix = (email: string | undefined): string => {
  if (!email) {
    return '';
  }

  const EMAIL_SEPARATOR = '###';

  return email.indexOf(EMAIL_SEPARATOR) !== -1 ? email.split(EMAIL_SEPARATOR)[1] : email;
};
